import { render } from "./PeopleToNotify.html?vue&type=template&id=92e90386&scoped=true"
import script from "./PeopleToNotify.js?vue&type=script&lang=js"
export * from "./PeopleToNotify.js?vue&type=script&lang=js"

import "./PeopleToNotify.css?vue&type=style&index=0&id=92e90386&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92e90386"]])

export default __exports__